import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const uploadScopeTypeEnum = createEnum({
    AVATAR: ['avatar', '用户头像'],
    IMAGE: ['image', '通用图片'],
    VIDEO: ['video', '通用视频'],
    EXCEL: ['excel', '导入导出'],
    DOCUMENT: ['document', '通用文档'],
    TEMP: ['temp', '临时'],
    DOCX_TEMPLATE: ['docx-template', 'docx 模版'],
});
export const UPLOAD_SCOPE_TYPES = enumValues(uploadScopeTypeEnum);
export const UPLOAD_SCOPE_TYPE_LABEL_MAP = enumLabelMap(uploadScopeTypeEnum);
export const systemLocaleEnum = createEnum({
    ZH_CN: ['zh-CN', '简体中文'],
    EN_US: ['en-US', 'English'],
    RU_RU: ['ru-RU', 'Русский'],
    AR_SA: ['ar-SA', 'العربية'],
    FR_FR: ['fr-FR', 'Français'],
    ES_ES: ['es-ES', 'Español'],
    PT_BR: ['pt-BR', 'Português (Brasil)'],
    DE_DE: ['de-DE', 'Deutsch'],
    IT_IT: ['it-IT', 'Italiano'],
});
export const SYSTEM_LOCALES = enumValues(systemLocaleEnum);
export const SYSTEM_LOCALE_LABEL_MAP = enumLabelMap(systemLocaleEnum);
export const DEFAULT_SYSTEM_LOCALE = systemLocaleEnum.ZH_CN;
/** Product-owned languages available for editable business content. */
export const contentTranslationLocaleEnum = createEnum({
    EN_US: ['en-US', '英语'],
    RU_RU: ['ru-RU', '俄语'],
    AR_SA: ['ar-SA', '阿拉伯语'],
    FR_FR: ['fr-FR', '法语'],
    ES_ES: ['es-ES', '西班牙语'],
    PT_BR: ['pt-BR', '葡萄牙语（巴西）'],
    DE_DE: ['de-DE', '德语'],
    IT_IT: ['it-IT', '意大利语'],
});
export const CONTENT_TRANSLATION_LOCALES = enumValues(contentTranslationLocaleEnum);
export const CONTENT_TRANSLATION_LOCALE_LABEL_MAP = enumLabelMap(contentTranslationLocaleEnum);
//# sourceMappingURL=common.js.map